import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'brt-archive-pagination',
  templateUrl: './archive-pagination.component.html',
  styleUrls: ['./archive-pagination.component.scss']
})
export class ArchivePaginationComponent {

  currentPage = 1;
  maxPages = 1;

  @Input() set page(currentPage: number) {
    this.currentPage = currentPage;
  }

  @Input() set maxPage(maxPage: number) {
    this.maxPages = maxPage;
  }

  @Output() goToNextPage = new EventEmitter<boolean>();
  @Output() goToPrevPage = new EventEmitter<boolean>();
  @Output() goToPage = new EventEmitter<number>();

  @ViewChild("inputElement") inputElement: ElementRef = new ElementRef(null);

  onKeyUp(event: KeyboardEvent) {
    const regexString = '^[0-9]+$';

    if(event.key === "Backspace" || event.key === "Delete" || event.key === "Enter" || event.key === "ArrowLeft" || event.key === "ArrowRight") {
      return true;
    } else if(event.key === "Tab") {
      return true;
    }

    const regexCheck = new RegExp(regexString).test(event.key);
    const maxCheck = this.currentPage <= this.maxPages;

    this.inputElement.nativeElement.reportValidity();

    return regexCheck && maxCheck;
  }

  inputChanged($event: Event) {
    const inputElement = $event.target as HTMLInputElement;
    const nextPage = parseInt(inputElement.value);
    if(nextPage > 0 && nextPage <= this.maxPages) {
      this.goToPage.emit(nextPage);
      inputElement.blur();
    }
  }

  onPrevPageClicked() {
    if(this.currentPage !== 1) {
      this.goToPrevPage.emit(true);
    }
  }

  onNextPageClicked() {
    if(this.currentPage !== this.maxPages) {
      this.goToNextPage.emit(true);
    }
  }
}
